export var OperationRead;
(function (OperationRead) {
    let type;
    (function (type) {
        type["ADD"] = "add";
        type["EDIT"] = "edit";
        type["DELETE"] = "delete";
        type["TRANSFER"] = "transfer";
    })(type = OperationRead.type || (OperationRead.type = {}));
})(OperationRead || (OperationRead = {}));
